var _defs, _g, _circle, _circle2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolygon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Polygon Tool") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "micrometer",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,2 L13,4 L15,15 L3,16 L4,1",
    id: "Line1",
    fill: "#000",
    fillOpacity: 0.4,
    stroke: "#000000"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 2,
    cx: 4,
    cy: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 2,
    cx: 13,
    cy: 4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 2,
    cx: 15,
    cy: 15
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    r: 2,
    cx: 3,
    cy: 16
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon);
export default __webpack_public_path__ + "static/media/polygon.5e9a5256a6298f32641f14d2ded275a1.svg";
export { ForwardRef as ReactComponent };